import { useTranslation } from 'next-i18next/pages';
import Image from 'next/image';
import React from 'react';

import { useMediaQuery } from '@/hooks/shared/useMediaQuery';

import Area from '@/components/apps/layouts/shared/Area';
import { AniSlideUp } from '@/components/shared/animations/basic';

import theme from '@/styles/theme';

const FEATURE_ICON_SIZES = '(min-width: 1024px) 60px, 40px';

export default function CustomFeaturesSection() {
  const { t } = useTranslation('common');

  const isDesktop = useMediaQuery({
    query: `(min-width: ${theme`screens.lg`})`,
  });

  const cards = [
    {
      imgUrl: '/images/apps/solution/custom/sec_01_img_01.svg',
      title: t('깔끔하게 원하는 소리만 감지'),
      description: t(
        '아기 울음소리, 반려동물 소리, 기침소리같은 특정한 소리만 인식하거나 특정 단어만 인식하는 등 원하는 소리만 감지할 수 있어요. 상황에 맞게 소음 제거 기술을 적용할 수도 있어요.',
      ),
    },
    {
      imgUrl: '/images/apps/solution/custom/sec_01_img_02.svg',
      title: t('Listen AI 기반 맞춤 솔루션'),
      description: t(
        '디플리의 주요 기술인 이상음 감지(Anomaly Detection), 목소리 감지(Voice Activity Detection), 사운드 이벤트 감지(Sound Event Detection)등 탄탄한 기반 기술력을 활용해요.',
      ),
    },
    {
      imgUrl: '/images/apps/solution/custom/sec_01_img_03.svg',
      title: t('스피커 프로파일링'),
      description: t(
        '소리에서 성별, 연령대, 발화자의 기분, 동일인 여부 등의 다양한 정보를 추출할 수 있어요. 목소리에 담긴 감정 등, 의미가 중요한 정보에 특화된 AI 기술로 다양한 상황에 맞게 커스텀이 가능해요.',
      ),
    },
  ];

  return (
    <section>
      <Area>
        <ul className="grid gap-[40px] lg:grid-cols-3 lg:gap-[clamp(40px,5vw,60px)]">
          {cards.map((card, index) => (
            <AniSlideUp
              key={index}
              delay={isDesktop ? index * 0.15 : 0}
              element="li"
            >
              <div>
                <div className="relative h-[40px] w-[40px] lg:h-[clamp(40px,5vw,60px)] lg:w-[clamp(40px,5vw,60px)]">
                  {/*
                   * 원본 StyledImage 는 position:relative 를 걸었지만 next/image 의 fill 이
                   * 인라인 style 로 position:absolute 를 넣어서 실제로는 적용된 적이 없다.
                   * Tailwind 유틸리티는 !important 라 그대로 옮기면 인라인 style 을 이겨
                   * 동작이 바뀌므로, 실제로 먹던 object-fit 만 유틸리티로 옮긴다.
                   */}
                  <Image
                    className="object-cover"
                    src={card.imgUrl}
                    alt="image"
                    fill
                    sizes={FEATURE_ICON_SIZES}
                  />
                </div>
                <h3 className="mb-[4px] mt-[16px] text-[22px] font-bold leading-[160%] tracking-[-0.44px] lg:mb-[clamp(4px,1vw,12px)] lg:mt-[clamp(16px,2vw,24px)] lg:text-[clamp(22px,2.333vw,28px)] lg:leading-[140%] lg:tracking-[-0.56px]">
                  {card.title}
                </h3>
                <p className="text-[16px] font-medium leading-[140%] tracking-[-0.32px] text-apps-brandGray600 lg:text-[clamp(16px,1.667vw,20px)] lg:leading-[160%] lg:tracking-[-0.4px]">
                  {card.description}
                </p>
              </div>
            </AniSlideUp>
          ))}
        </ul>
      </Area>
    </section>
  );
}
